import { useLanguage } from "@/hooks/useLanguage";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const Hero = () => {
  const { t } = useLanguage();
  const heroAnimation = useScrollAnimation();
  return <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-muted/20 to-background relative overflow-hidden">
      {/* City Skyline Animation */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden opacity-20">
        <svg 
          className="w-full h-full" 
          viewBox="0 0 1200 400" 
          preserveAspectRatio="xMidYMid slice"
          fill="none"
        >
          <path
            d="M0,400 L0,300 L80,300 L80,180 L160,180 L160,220 L240,220 L240,140 L320,140 L320,260 L400,260 L400,160 L480,160 L480,200 L560,200 L560,120 L640,120 L640,240 L720,240 L720,100 L800,100 L800,210 L880,210 L880,170 L960,170 L960,250 L1040,250 L1040,190 L1120,190 L1120,230 L1200,230 L1200,400 Z"
            stroke="hsl(var(--foreground))"
            strokeWidth="1.5"
            fill="none"
            className="animate-draw-skyline"
          />
        </svg>
      </div>
      
      {/* Content */}
      <div 
        ref={heroAnimation.ref as any}
        className={`container mx-auto px-4 sm:px-6 relative z-10 ${heroAnimation.isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
      >
        <div className="max-w-6xl mx-auto text-center">
          <div className="space-y-6 sm:space-y-8 md:space-y-12">
            <div className="space-y-3 sm:space-y-4 md:space-y-6">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-light leading-tight sm:leading-[0.9] tracking-tight text-foreground">
                {t("hero.title")}
              </h1>
              <div className="w-12 sm:w-16 md:w-24 h-px bg-gradient-to-r from-primary to-secondary mx-auto"></div>
            </div>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-light text-foreground max-w-3xl mx-auto">
              Redefining Hospitality Excellence
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;